
<div class="chart">
  <app-mask [mask]="mask" [color]="'#f3f3f3'"></app-mask>
  <canvas [id]="canvasId"></canvas>
</div>
